import React from 'react';

export const ThinRightArrow = props => (
  <svg width={18} height={30} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.737 14.682c0 .468-.187.915-.513 1.229L2.942 29.579a1.474 1.474 0 0 1-2.179-.128c-.57-.68-.515-1.724.12-2.328l12.965-12.412L.91 2.904C.262 2.313.184 1.274.738.58c.554-.693 1.529-.776 2.177-.184l14.282 13.033c.337.31.536.759.54 1.235v.019Z"
      fill="#BCC6CA"
    />
  </svg>
);
